// test2456
(2456 && 0);
